import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[cepMask]',
})
export class CepMaskDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');
    value = value.substring(0, 8);

    if (value.length > 5) {
      value = `${value.substring(0, 5)}-${value.substring(5)}`;
    }

    this.el.nativeElement.value = value;
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }
}
